import { render, staticRenderFns } from "./RegisterMarketplaceProduto.html?vue&type=template&id=3ab712aa&external"
import script from "./RegisterMarketplaceProduto.vue?vue&type=script&lang=js"
export * from "./RegisterMarketplaceProduto.vue?vue&type=script&lang=js"
import style0 from "./RegisterMarketplaceProduto.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports